var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',[_c('case-detail',{attrs:{"case-id":_vm.caseId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }